<div class="sidebar" *ngIf="passengerInfo">
		<app-sidebar-header
			title="{{ (passengerInfo?.title + ' ' + passengerInfo?.name + ' ' + passengerInfo?.surname) | uppercase }}"
			[confirmation]="showSave"
		>
				<div custom-label *ngIf="_hasFrequentFlyer">
					<app-svg
						classes="logo__booking-loyalty-program {{ logoClasses }}"
						alt="{{ ('bookingDetails.alt.milesGo' | ibeadmin:'sync') + ' ' + (passengerInfo.tierLevelFF) + ' ' + ('bookingDetails.alt.logo' | ibeadmin:'sync') }}"
						svg="sprite.svg#{{ loyaltyLogo }}"
						aria-hidden="true">
					</app-svg>
				</div>
				<div actions *ngIf="showSave">
					<button
						class="button button--small"
						(click)="saveSidebar()"
						[disabled]="saving"
					>
						{{'bookingDetails.text.save' | ibeadmin:'sync'}}
					</button>
				</div>
		</app-sidebar-header>

	<app-loading *ngIf="saving"></app-loading>

		<ng-container *ngIf="notif.show">
			<app-notification [classes]="'top-gap'" [style]="notif.style" [title]="notif.title">
				<div message *ngFor="let message of notif.message">
					{{message | ibeadmin: 'sync'}}
				</div>
				<div actions>
					<button class="button" (click)="hideNotifications()">
						{{'bookingDetails.button.close' | ibeadmin:'sync'}}
					</button>
				</div>
			</app-notification>
		</ng-container>

		<div class="sidebar__body sl--scrollable" #sidebar__body>
			<form class="sidebar__form sidebar__form--view-only">
				<div class="form--view-mode">
					<div class="form-field--row grid no-padding">
						<div class="form-field col-6 col-tp-6 col-p-6">
							<span class="label">{{'bookingDetails.label.firstName' | ibeadmin:'sync'}}</span>
							<span class="value">{{ passengerInfo?.name | uppercase }}</span>
						</div>
						<div class="form-field col-6 col-tp-6 col-p-6">
							<span class="label">{{'bookingDetails.label.lastName' | ibeadmin:'sync'}}</span>
							<span class="value">{{ passengerInfo?.surname | uppercase}}</span>
						</div>
					</div>
					<div class="form-field--row grid no-padding">
						<div class="form-field col-6 col-tp-6 col-p-6">
							<span class="label">{{'bookingDetails.label.gender' | ibeadmin:'sync'}}</span>
							<span *ngIf="passengerInfo?.sex && passengerInfo?.sex == 'Female'" class="value">{{ 'bookingDetails.label.female' | ibeadmin:'sync' }}</span>
							<span *ngIf="passengerInfo?.sex && passengerInfo?.sex == 'Male'" class="value">{{ 'bookingDetails.label.male' | ibeadmin:'sync' }}</span>
						</div>
						<div class="form-field col-6 col-tp-6 col-p-6">
							<span class="label">{{'bookingDetails.label.dateOfBirth' | ibeadmin:'sync'}}</span>
							<span class="value">{{ passengerInfo?.dateOfBirth | dateIndra }}</span>
						</div>
					</div>
				</div>
			</form>

			<app-passenger-detail-emergency-contact *ngIf="notInfant"></app-passenger-detail-emergency-contact>

			<app-passenger-detail-personal-documents></app-passenger-detail-personal-documents>

			<app-frequent-flyer *ngIf="notInfant"></app-frequent-flyer>

			<app-passenger-detail-contacts *ngIf="notInfant"></app-passenger-detail-contacts>

			<button
				*ngIf="showSave"
				class="button full-width"
				(click)="saveSidebar()"
				[disabled]="saving">
				{{'bookingDetails.text.updatePassengerData' | ibeadmin:'sync'}}
			</button>
		</div>
</div>
